import {
  SHARED_INVITE_USER_FAIL,
  SHARED_INVITE_USER_REQUEST,
  SHARED_INVITE_USER_SUCCESS,
  SHARED_INVITE_USER_BY_EMAIL_FAIL,
  SHARED_INVITE_USER_BY_EMAIL_REQUEST,
  SHARED_INVITE_USER_BY_EMAIL_SUCCESS
} from '../../types/user/inviteTypes';

export const userInviteRegisterReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_INVITE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SHARED_INVITE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        sharedUserInfo: payload,
        error: '',
      };
    case SHARED_INVITE_USER_FAIL:
      return {
        ...state,
        loading: false,
        sharedUserInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const userInviteRegisterByEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHARED_INVITE_USER_BY_EMAIL_REQUEST:
      return {
        ...state,
        emailLoading: true,
      };
    case SHARED_INVITE_USER_BY_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoading: false,
        sharedUserInfo: payload,
        emailError: '',
      };
    case SHARED_INVITE_USER_BY_EMAIL_FAIL:
      return {
        ...state,
        emailLoading: false,
        sharedUserInfo: [],
        emailError: payload,
      };
    default:
      return state;
  }
};